export function formatActionType(reducerName) {
  if (typeof reducerName !== 'string' || reducerName?.length === 0) {
    throw new Error('You must pass a reducer name as a string to your action');
  }
  return reducerName?.replace(/^\w/, c => c.toUpperCase());
}
export const DATA_REQUEST_BEGIN = reducerName =>
  `[${formatActionType(reducerName)} Data] REQUEST BEGIN`;
export const DATA_REQUEST_LOADING = reducerName =>
  `[${formatActionType(reducerName)} Data] REQUEST LOADING`;
export const DATA_REQUEST_COMPLETED = reducerName =>
  `[${formatActionType(reducerName)} Data] REQUEST COMPLETED`;
export const DATA_REQUEST_FAILURE = reducerName =>
  `[${formatActionType(reducerName)} Data] REQUEST FAILURE`;
export const DATA_REQUEST_CANCELLED = reducerName =>
  `[${formatActionType(reducerName)} Data] PREVIOUS REQUEST CANCELLED`;
export const DATA_REQUEST_STATUS_RESET = reducerName =>
  `[${formatActionType(reducerName)} Data] REQUEST STATUS RESET`;

export function withDataRequestActionType(reducerName) {
  return {
    BEGIN: DATA_REQUEST_BEGIN(reducerName),
    LOADING: DATA_REQUEST_LOADING(reducerName),
    COMPLETED: DATA_REQUEST_COMPLETED(reducerName),
    FAILURE: DATA_REQUEST_FAILURE(reducerName),
    CANCELLED: DATA_REQUEST_CANCELLED(reducerName),
    RESET: DATA_REQUEST_STATUS_RESET(reducerName),
  };
}
export const actionReturn = (type, payload) => {
  if (payload) {
    return { type, ...payload };
  }
  return { type };
};
export const dataRequestBegin = (reducerName, payload) => {
  const type = DATA_REQUEST_BEGIN(reducerName);
  return actionReturn(type, payload);
};
export const dataRequestLoading = (reducerName, payload) => {
  const type = DATA_REQUEST_LOADING(reducerName);
  return actionReturn(type, payload);
};
export const dataRequestCompleted = (reducerName, payload) => {
  const type = DATA_REQUEST_COMPLETED(reducerName);
  return actionReturn(type, payload);
};
export const dataRequestFailure = (reducerName, payload) => {
  const type = DATA_REQUEST_FAILURE(reducerName);
  return actionReturn(type, payload);
};
export const dataRequestCancelled = (reducerName, payload) => {
  const type = DATA_REQUEST_CANCELLED(reducerName);
  return actionReturn(type, payload);
};
export const dataRequestStatusReset = (reducerName, payload) => {
  const type = DATA_REQUEST_STATUS_RESET(reducerName);
  return actionReturn(type, payload);
};
